module.exports = __webpack_public_path__ + "media/images/eu1-2202800d897d59968eab3ff19dbf2589.svg";